import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/nav/log/visit/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: 'nav/log/visit/',
    method: 'post',
    data
  })
}
